// Does a string only contain letters or numbers?
const isAlphaNumeric = (str: string) => {
    return /^[a-zA-Z0-9]+$/.test(str);
};

export { isAlphaNumeric };
